var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

export default isNumeric;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/isNumeric.js
// module id = 810
// module chunks = 14